import { render, staticRenderFns } from "./CommonSwiper.vue?vue&type=template&id=144b7af6&scoped=true"
import script from "./CommonSwiper.vue?vue&type=script&lang=js"
export * from "./CommonSwiper.vue?vue&type=script&lang=js"
import style0 from "./CommonSwiper.vue?vue&type=style&index=0&id=144b7af6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144b7af6",
  null
  
)

export default component.exports